<template>
  <div class="convey911-languageCode">
    <span>{{ languageCode ? languageCode.substring(0, 2) : "" }}</span>
  </div>
</template>

<script>
export default {
  name: "LanguageCode",
  props: {
    languageCode: String,
  },
  data() {
    return {};
  },
};
</script>



<style lang="scss">
.convey911-languageCode {
  color: #fff;
  background: rgba(227, 82, 5, 0.7803921569);
  padding: 7px;
  border-radius: 50%;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>